import { Skeleton } from '@mui/material';
import { Image } from "antd";
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import { getFileActionWithRetry } from '../../../../../../redux/files/actions';
import { makeGetSignedUrlSelector } from '../../../../../../redux/files/selectors';

const InlineImageRenderComponent = ({ fileid, signedUrl }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!signedUrl) {
      dispatch(getFileActionWithRetry(fileid));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileid, signedUrl]);

  const handleError = useCallback(async () => {
    setLoading(true);
    await dispatch(getFileActionWithRetry(fileid));
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileid]);

  const handleClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <div className="inline-image-container">
      <div className="inline-image-wrapper">
        {signedUrl || loading ? (
          <Image
            className="inline-image"
            src={signedUrl}
            alt={`image-${fileid}`}
            onError={handleError}
            onClick={handleClick}
          />
        ) : (
          <Skeleton width={300} height={200} animation="pulse" variant="rectangular" sx={{ borderRadius: '4px' }} />
        )}
      </div>
    </div>
  );
};

const makeMapStateToProps = () => {
  const getSignedUrlSelector = makeGetSignedUrlSelector();

  return (state, ownProps) => ({
    signedUrl: getSignedUrlSelector(state, { fileId: ownProps.fileid }),
  });
};

export default connect(makeMapStateToProps)(InlineImageRenderComponent);
